module.exports = __webpack_public_path__ + "img/info-icon.e931fe6f.svg";